import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { Subscription } from 'rxjs';
import { TableBtn, TableColumn } from 'src/app/shared/interfaces';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from 'src/app/_service/message-service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Permission } from 'src/app/util/enums/permission.enum';
import { TariffManagementService } from './services/tariff-management-service';
import { HttpErrorResponse } from '@angular/common/http';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { AuthenticationService } from 'src/app/_services';
import { RouteConstants } from 'src/app/util/route.constants';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';

export interface tariffData {
  id: number;
  country_code: string;
  vendor_id: string;
  currency: string;
  type: string;
  name: string;
  vendor_name: string;
  tariff_detail: {
    start_time: string;
    end_time: string;
    type: string;
    tax: string;
    price: number;
    step_size: number;
    day_of_week: string[];
  }[];
}

export interface tariffDataDetails {
  id: number;
  country_code: string;
  vendor_id: string;
  currency: string;
  type: string;
  name: string;
  subid: number;
  start_time: string;
  end_time: string;
  subtype: string;
  tax: string;
  price: number;
  step_size: number;
  day_of_week: string[];
  tariff_detail: [];
}



@Component({
  selector: 'telio-tariff-management',
  templateUrl: './tariff-management.component.html',
  styleUrls: ['./tariff-management.component.scss']
})

export class TariffManagementComponent implements OnInit {
  @ViewChild('viewProfile', { static: false }) viewProfile: TemplateRef<any>;
  columns: TableColumn[];
  tcolumns: TableColumn[];
  buttons: TableBtn[];
  filterPlaceholder = '';
  actionHeader = '';
  subscription: Subscription = new Subscription;
  initialData: any;
  initialDataId: any;
  actionFeatureLabel = '';
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  totalDataCountDetail = 0;
  sortColumn = '';
  sortDirection = 'asc';
  actionFeatureFlag = false;
  tariffData: tariffData[];
  tariffDataDetails: tariffDataDetails[];
  tariffTableData = [];
  variableType;
  energyType;

  constructor(
    public translate: TranslateService,
    readonly exportCSVService: ExportCSVService,
    private toastr: SnackbarService,
    private userInfoService: UserInfoService,
    readonly route: ActivatedRoute,
    public dialog: MatDialog,
    private tariffService: TariffManagementService,
    private authService: AuthenticationService,readonly breadcrumbService: BreadcrumbService,
    private router: Router) {
    this.rerender(this.pageList, '')
    this.columns = [
      { columnDef: 'name', header: 'tarrif.tname', cell: (element: tariffData) => `${element.name}`, sortingDisabled: false, width: 'auto', isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ) },
      { columnDef: 'currency', header: 'tarrif.currency', cell: (element: tariffData) => `${element.currency}`, sortingDisabled: false, width: 'auto' },
      { columnDef: 'type', header: 'tarrif.type', cell: (element: tariffData) => `${element.type}`, sortingDisabled: false, width: 'auto' },
      { columnDef: 'vendor_name', header: 'cpoList.cpoName', cell: (element: tariffData) => `${element.vendor_name}`, sortingDisabled: false, width: 'auto' },
    ];

    this.buttons = [{ styleClass: 'submit', icon: 'edit', payload: (element: tariffData) => `${element.id}`, action: 'edit', tooltip: 'faq.edit', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) }];
    this.userInfoService.isAdminGroup() && this.buttons.push(
      { styleClass: 'submit', icon: 'delete', payload: (element: tariffData) => `${element.id}`, action: 'delete', tooltip: 'faq.delete', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.DELETE) }
    );

    this.actionHeader = 'tarrif.action';
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
    this.actionFeatureLabel = 'tarrif.Create';
    this.actionFeatureFlag = this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.CREATE);
  }

  ngOnInit(): void { }

  getTariffList(value: any, searchFilter: string = ''): void {
    this.tariffService.getTariffList(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((res: any) => {
      if (!!res && !!res.content) {
        this.tariffData = res.content;
        this.totalDataCount = res.total_items;
        this.setTariffListMap(this.tariffData)
      }
    },
      (err: HttpErrorResponse) => {
        this.tariffData = [];
        this.totalDataCount = 0;
        this.toastr.error(this.translate.instant('tarrif.responseFailed'));
      }
    );
  }

  deleteTariff(id): void {
    const tariff = this.tariffData.find(tariff => tariff.id === id);
    const tariffName = tariff.name;
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('tarrif.delete'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('tarrif.deletemessage', { tariffName: tariffName }) }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.subscription.add(this.tariffService.deleteTariff(id).subscribe(resp => {
          if (resp) {
            this.toastr.success(this.translate.instant('faq.deleteSuccess'));
            this.rerender(this.pageList);
          } else {
            this.toastr.error(resp)
          }
        },error => {
          this.toastr.error(error.message);
        }));
      }
    });
  }

  editTariff(id) {
    this.authService.setTariffDialog(false);
    let data = this.tariffData.filter(x => x.id == id);
    if (!!data && data.length > 0) {
      let objToSend: NavigationExtras = {
        queryParams: {
          "tariffData": JSON.stringify(data[0]),
          "isEdit": true,
        },
        skipLocationChange: true
      };
      this.router.navigate(['/dashboard/tariff-management/tariff/create', { routeID: this.route.snapshot.paramMap.get('routeID') }], objToSend);
      this.breadcrumbService.emitBreadCrumbs(RouteConstants.TARIFF_MGMT_EDIT);
    }
  }

  linkClick(event) {
    if (event.column.columnDef == "name") {
      this.tariffService.getTariffById(event.row.id).subscribe(res => {
        this.variableType = res.type;
        this.energyType = res.tariff_detail[0].type
        const commonArray = this.tcolumns = [
          { columnDef: 'type', header: 'tarrif.type', cell: (element: tariffDataDetails) => `${element.subtype}`, sortingDisabled: false, width: 'auto' },
          { columnDef: 'price', header: 'tarrif.price', cell: (element: tariffDataDetails) => `${element.price}`, sortingDisabled: false, width: 'auto' },
          { columnDef: 'start_time', header: 'tarrif.start_time', cell: (element: tariffDataDetails) => `${element.start_time}`, sortingDisabled: false, width: 'auto' },
          { columnDef: 'end_time', header: 'tarrif.end_time', cell: (element: tariffDataDetails) => `${element.end_time}`, sortingDisabled: false, width: 'auto' },
          { columnDef: 'day_of_week', header: 'tarrif.days', cell: (element: tariffDataDetails) => `${element.day_of_week}`, sortingDisabled: false, width: 'auto', isBullet: true },
        ]; if (this.variableType === 'FIXED') {
          if (this.energyType === 'TIME') { commonArray.push({ columnDef: 'step_size', header: 'tarrif.step_size', cell: (element: tariffDataDetails) => `${element.step_size}`, sortingDisabled: false, width: 'auto' }) }
        }
        if (!!res) {
          this.tariffDataDetails = [res];
          let empty = 'NA';
          this.tariffDataDetails['name'] = !res['name'] ? empty : this.capitalizeFirstLetter(res['name']);
          this.tariffDataDetails['vendor_id'] = !res['vendor_id'] ? empty : res['vendor_id'];
          this.tariffDataDetails['currency'] = !res['currency'] ? empty : res['currency'];
          this.tariffDataDetails['country_code'] = !res['country_code'] ? empty : res['country_code'];
          this.tariffDataDetails['type'] = !res['type'] ? empty : res['type'];
          this.tariffTableData = !!res.tariff_detail ? res.tariff_detail : [];
          this.totalDataCountDetail = this.tariffTableData.length
          this.tariffTableData.map((detail: any) => {
            detail.start_time = this.convertTo12HourFormat(detail.start_time);
            detail.end_time = this.convertTo12HourFormat(detail.end_time);
            detail.subtype = detail.type;
            detail.tax = detail.tax;
            detail.price = detail.price;
            detail.step_size = !!detail.step_size ? detail.step_size : 'NA';
            detail.day_of_week = this.sortDaysOfWeek(detail.day_of_week);
          }); this.initialDataId = this.tariffTableData;
          let dialogRef = this.dialog.open(this.viewProfile, {
            height: '550px',
            width: '800px'
          }).afterClosed().subscribe();
        } else {
          this.toastr.error(this.translate.instant('generalTable.noRecord'));
        }
      }, error => {
        this.toastr.error(this.translate.instant('generalTable.noRecord'));
      })
    }
  }

  buttonClick(event) {
    event[0] == 'edit' ? this.editTariff(event[1]) : this.deleteTariff(event[1]);
  }

  checkPermission(id: number, permission: string): boolean {
    return this.userInfoService.filterPermission(id, permission);
  }

  actionFeature(event) {
    this.authService.setTariffDialog(false);
    this.router.navigate(['/dashboard/tariff-management/tariff/create', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.TARIFF_MGMT_CREATE);
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerender(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerender(this.pageList, '');
  }

  loadDataDetail(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
  }

  sortClickDetail(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
  }

  applyFilter(filteredData: string) {
    this.rerender(this.pageList, filteredData)
  }

  actionClick() {
    this.rerender(this.pageList);
  }

  rerender(value: any, searchFilter?: string) {
    this.getTariffList(value, searchFilter)
  }

  actionCSV() {
    const options = {
      filename: this.translate.instant('tarrif.tarriffileName'),
      showTitle: false,
      title: this.translate.instant('tarrif.tarriffileName'),
      useKeysAsHeaders: true,
    }
    this.tariffService.getTariffList(1, this.totalDataCount, this.sortColumn, 'asc', '').subscribe((res: any) => {
      if (!!res && !!res.content) {
        this.initialData = res.content;
        this.setTariffListMap(this.initialData)
        const filteredData = this.initialData.map(item => ({
          name: item.name,
          currency: item.currency,
          type: item.type,
        }));
        this.exportCSVService.exportCSV(options, filteredData);
      }
    });

  }

  actionCSVId() {
    const options = {
      filename: this.translate.instant('tarrif.tarriffileName'),
      showTitle: false,
      title: this.translate.instant('tarrif.tarriffileName'),
      useKeysAsHeaders: true,
    }
    const filteredData = this.initialDataId.map(item => ({
      Type: item.type,
      Price: item.price,
      StartTime: item.start_time,
      EndTime: item.end_time,
      Days: item.day_of_week.toString(),

    }));
    this.exportCSVService.exportCSV(options, filteredData);
  }


  capitalizeFirstLetter(input: string): string {
    return input ? input.charAt(0).toUpperCase() + input.slice(1) : '';
  }

  sortDaysOfWeek(daysOfWeek) {
    const order = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
    const sortedDaysOfWeek = daysOfWeek.sort((day1, day2) => {
      const index1 = order.indexOf(day1);
      const index2 = order.indexOf(day2);
      return index1 - index2;
    });
    return sortedDaysOfWeek;
  }

  convertTo12HourFormat(timeString: string): string {
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = (hour % 12 === 0 ? 12 : hour % 12).toString().padStart(2, '0');
    return `${formattedHour}:${minutes} ${period}`;
  }
  setTariffListMap(data) {
    data.map((item: any, i: number) => {
      let empty = 'NA';
      item.id = !item.id ? empty : item.id;
      item.name = !item.name ? empty : this.capitalizeFirstLetter(item.name);
      item.currency = !item.currency ? empty : item.currency;
      item.type = !item.type ? empty : item.type;
      item.vendor_name = !item.vendor_name ? empty : item.vendor_name;
    });
  }
}